export const INK_MATCH_TYPES = {
  PANTONE: 'pantone'
};
export const NEED_A_MATCH = 'Need A Pantone Color Match?';
export const ADD_YOUR_COLORS =
  'Add your brand colors to orders of 6 items or more';
export const EDIT_YOUR_COLORS = 'Edit Your Pantone Colors';
